<template>
  <div v-if="isLoggedIn" class="lavendla-memorial-creator__sticky-admin-bar">
    <div class="container">
      <div class="lavendla-memorial-creator__sticky-admin-bar__wrapper">
        <p>{{ texts.loggedIn }}</p>
        <div class="lavendla-memorial-creator__sticky-admin-bar__buttons">
          <template v-if="isEditMode">
            <button
              v-if="!isPublished"
              class="btn btn-cta btn-sm"
              @click.prevent="publishPage"
              v-text="texts.publish"
            />
            <button
              v-else
              class="btn btn-cta btn-sm"
              @click.prevent="setState({ isEditMode: false })"
              v-text="texts.done"
            />
          </template>
          <template v-else>
            <button
              v-if="isLoggedIn"
              class="btn outline btn-sm"
              @click.prevent="setState({ isEditMode: true })"
              v-text="texts.edit"
            />
            <button
              v-if="isLoggedIn"
              class="btn outline btn-sm"
              @click.prevent="logOut"
              v-text="texts.logOut"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'CreatorAdminBar',
  components: {},

  data() {
    return {
      texts: lavendlaObituary.creator,
    };
  },

  computed: {
    ...mapState('creator', ['isEditMode', 'isLoggedIn', 'isPublished']),
  },

  methods: {
    ...mapMutations('creator', ['setState']),
    ...mapActions('creator', ['publishPage', 'logOut']),
    startEditing() {
      this.setState({ isEditMode: true });
    },
  },
};
</script>
